// «Журналы S3»: вкладки раздела; «Поиск» (SM7, правки заказчика 04.11) — условия, ход, строки, время в МСК.
// Время менеджера — МСК; в Москве нет перехода на летнее время с 2014 года, поэтому сдвиг постоянный (+3 ч).

import { JOURNAL_S3_PATH, JOURNAL_S3_SEARCH_PATH } from '../../config/journal-s3-routes';

export { JOURNAL_S3_PATH, JOURNAL_S3_SEARCH_PATH };

export const JOURNAL_S3_TABS = [
  { key: 'exports', path: JOURNAL_S3_PATH, label: 'Выгрузки' },
  { key: 'search', path: JOURNAL_S3_SEARCH_PATH, label: 'Поиск' },
];

export const journalS3Section = (pathname) => (
  (pathname || '').replace(/\/+$/, '').endsWith('/search') ? 'search' : 'exports'
);

const MSK_OFFSET_MS = 3 * 3600 * 1000;

export const formatMsk = (iso) => {
  if (!iso) return '—';
  const moment = new Date(iso);
  if (Number.isNaN(moment.getTime())) return '—';
  const shifted = new Date(moment.getTime() + MSK_OFFSET_MS).toISOString();
  const millis = shifted.slice(20, 23);
  return `${shifted.slice(0, 10)} ${shifted.slice(11, 19)}${millis === '000' ? '' : `.${millis}`}`;
};

export const STATUS_TEXT = {
  queued: 'в очереди',
  running: 'ищется',
  done: 'готово',
  failed: 'ошибка',
};

export const STATUS_COLOR = {
  queued: 'default',
  running: 'blue',
  done: 'green',
  failed: 'red',
};

export const MATCH_LABEL = {
  address: 'адрес',
  gap: 'окно смены адреса',
};

export const formatSize = (bytes) => {
  if (!bytes) return '0 Б';
  if (bytes < 1024) return `${bytes} Б`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} КБ`;
  if (bytes < 1024 * 1024 * 1024) return `${(bytes / 1024 / 1024).toFixed(1)} МБ`;
  return `${(bytes / 1024 / 1024 / 1024).toFixed(2)} ГБ`;
};

export const progressText = (job) => {
  if (!job) return '';
  const progress = job.progress || {};
  if (job.status === 'queued') return 'ждёт службу journal-s3-index';
  if (job.status === 'failed') return job.error || 'ошибка';
  const days = progress.days_total !== undefined ? `сутки ${progress.days_done || 0} из ${progress.days_total}` : '';
  const size = progress.bytes ? `скачано ${formatSize(progress.bytes)}` : '';
  const parts = [days, size];
  if (job.status === 'done') {
    parts.unshift(`найдено ${job.rows_found ?? 0}`);
    if (job.truncated) parts.push('на странице — первые 20 000, в XLSX — все');
  }
  return parts.filter(Boolean).join(' · ');
};

// Невыгруженные сутки: «ещё не выгружены» — сутки D уходят в бакет к ~03:30 МСК D+1; прочие — не выгружены вовсе.
export const missingDaysTexts = (progress) => {
  const missing = (progress && progress.missing_days) || [];
  const label = (item) => `${item.day} (${String(item.installation_uuid || '').slice(0, 8)})`;
  const late = missing.filter((item) => item.pending).map(label);
  const absent = missing.filter((item) => !item.pending).map(label);
  const texts = [];
  if (absent.length) texts.push(`Сутки не выгружены в бакет — не просмотрены: ${absent.join(', ')}`);
  if (late.length) texts.push(`Сутки ещё не выгружены (появятся после 03:15 МСК следующих суток): ${late.join(', ')}`);
  return texts;
};

export const isActive = (jobs) => (jobs || []).some((item) => item.status === 'queued' || item.status === 'running');

export const EMPTY_FORM = { externalIp: '', login: '', clientIp: '', resource: '', since: '', until: '' };

// Значение <input type="datetime-local"> — «ГГГГ-ММ-ДДTчч:мм[:сс]» без зоны: сервер читает его как МСК.
export const buildQueryPayload = (form, confirm = false) => {
  const payload = { since: (form.since || '').trim() };
  const fields = [['external_ip', form.externalIp], ['login', form.login], ['client_ip', form.clientIp],
    ['resource', form.resource], ['until', form.until]];
  fields.forEach(([key, value]) => {
    const text = (value || '').trim();
    if (text) payload[key] = text;
  });
  if (confirm) payload.confirm = true;
  return payload;
};

export const hasCondition = (form) => [form.externalIp, form.login, form.clientIp, form.resource]
  .some((value) => (value || '').trim());

export const conditionsText = (job) => [
  job.external_ip && `внешний IP ${job.external_ip}`,
  job.login && `логин ${job.login}`,
  job.client_ip && `IP клиента ${job.client_ip}`,
  job.resource && `ресурс ${job.resource}`,
].filter(Boolean).join(' · ');

export const estimateText = (estimate) => {
  if (!estimate) return '';
  return `серверов ${estimate.installations} · суток ${estimate.days} · скачать ≈ ${formatSize(estimate.bytes)}`;
};

export const resultRows = (job) => (job?.rows || []).map((row) => ({
  ...row,
  key: `${row.installation_uuid}:${row.id}`,
  started_msk: formatMsk(row.ts),
  ended_msk: formatMsk(row.last_ts),
  match_label: MATCH_LABEL[row.match] || '',
}));

export const queryParamsOf = (search) => {
  const params = new URLSearchParams(search || '');
  const id = Number(params.get('client_id'));
  return { clientId: Number.isInteger(id) && id > 0 ? id : null, login: params.get('login') || '' };
};

// Колесо над полем даты: не чаще одного шага за `ms` (владелец 04.11: «сделать бы менее чувствительным»).
export const wheelGate = (ms) => {
  let last = -Infinity;
  return (now) => {
    if (now - last < ms) return false;
    last = now;
    return true;
  };
};
